// React
import React, { Component } from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from '../../actions';

//Utils
import { toArray } from '../../utils/lodashUtils';

// Components
import { Hero } from '../../components/Hero';
import { FluidSection } from '../../components/FluidSection';
import { Content } from '../../components/Content';
import { List } from '../../components/List';
import { StretchCard } from '../../components/StretchCard';
import { StretchVideo } from '../../components/StretchVideo';
import { VideoModal } from '../../components/VideoModal';
import ProviderCardSection from 'components/ProviderCardSection/index';


import { Calendar } from '../../components/Calendar';
import FlatButton from 'material-ui/FlatButton';
// import { Button } from '../../components/Button';
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
// import { LogoAvatar } from '../../components/LogoAvatar';

// Others
import { constants } from '../../constants';
// import { CompanyDetailStyles } from './styles';

import SwipeableViews from 'react-swipeable-views';

class CompanyDetailPage extends Component {

    constructor () {
        super();
        this.state = {
            buttonVisible: true,
            calendarFlexStyle: {},
            company: null,
            height: 0,
            heroHeight: '450px',
            heroOrientation: 'row',
            mainHeroButtonIcon: '',
            mainHeroButtonText: 'Book Your Consultation',
            provider: null,
            randomCards: null,
            service: null,
            showCalendar: false,
            showModal: false,
            viewIndex: 0,
            width: 0,
        };

        // this.handleOpenVideoModal = this.handleOpenVideoModal.bind(this);
    }
    
    // ########## LIFE CYCLE HOOKS ############## //
    
    componentWillMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
        // this.props.getDBProviders();
        // this.setState(this.getNRandomNumbers(0, props.experts.length-1, 3)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
    }

    componentDidUpdate(nextState){
        if (this.state.width !== nextState.width){
            if ( this.state.width < 800 && (this.state.heroOrientation !== 'column')) {
                this.setState({
                    heroOrientation: 'column'
                });
                
            }else if ( this.state.width >= 800 && (this.state.heroOrientation !== 'row')) {
                this.setState({
                    heroOrientation: 'row'
                });
            }
        }
    }
    
    componentDidMount(){
            // Recive window dimetions
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
            // AIUTOFOCUS THE SEARCH
            // Go to the top of the page on load
            document.getElementById('top').scrollIntoView();
            // window.scrollTo(0, 0);
            // this.top.scrollTop = this.top.scrollHeight;
            this.props.getDBProviders();
            this.props.getDBServices();
            this.props.getDBProviderCompanies();
            this.props.getDBServiceCategories();
            this.props.getDBServiceModules();
        }
        
        componentWillReceiveProps(nextProps) {
            if (nextProps.providers && nextProps.services && nextProps.companies) {
                this.getCompany(nextProps);
            }
        }

    // ########################################### //


    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    getCompany = (props) => {
        return props.companies.map((company)=> {
            // console.log('company!!',company );
            
            if (company._id === props.match.params.id) {
                    this.setState({
                        company,
                        
                    })
            }
            
        });
    }

    getCompanyProviders = (company) => {
        console.log('thecompany',company)

        const providers = (company && this.props.providers) && this.props.providers.map(provider => {
            // console.log('theprovider',provider)
            if (provider.providerCompany === (company._id)){
                console.log('theFilterdProvider',provider)
                    return provider
                }
            });
        return toArray(providers).filter(provider => provider);

    }

    handleHeroMobileChanges = () => {
        // console.log( 'HHMC')
        if ( this.state.width < 800 ) {
            this.setState({
                heroOrientation: 'column'
            });
        }
    }


    render(){

        const { provider, company } = this.state;
        let providerFullName = '';
        if (provider) {
            providerFullName = `${provider.name && provider.name.first} ${provider.name && provider.name.last}`;
        }
        // console.log(`%c${JSON.stringify(provider)} ${JSON.stringify(company)} `,'color: greenyellow');
        // console.log('props.match', this.props.match, this.state.company) 
        // console.log('this.props.providers', this.props.providers) 
        // console.log('dbprovider', provider) 
        // console.log('this.props.companiestate.company', this.state.company) 
        // console.log('getCompanyProviders', this.getCompanyProviders(this.state.company)) 
        

        return (
            <div style={constants.layout.container}>
                { company &&
                    <div>
                        <Hero
                            id="companyHero"
                            titleColor={constants.color.primary}
                            tintOpacity={0.04}
                            mainTitleText={company.name}
                            subTitleText={`${company.address.city}, ${company.address.province}`}
                            avatarImageURL={company.logoURL}
                            height={400}
                            orientation={this.state.heroOrientation}
                        />
                        <ProviderCardSection
                            services={this.props.services}
                            providers={this.getCompanyProviders(this.state.company)}
                        />
                    
                    </div>
                }

            </div>
        );
    };
    };

    const mapStateToProps = ({provider, service, company}) => {
        return {
            providers: provider.providers,
            services: service.services,
            serviceCategories: service.categories,
            serviceModules: service.modules,
            companies: company.providerCompanies
        };
    }

export const CompanyDetail = connect(mapStateToProps, actions)(CompanyDetailPage)



// WEBPACK FOOTER //
// ./src/js/containers/CompanyDetail/CompanyDetail.jsx